import React from 'react'
import PropTypes from 'prop-types'
import { initialState, reducer, StateContext } from '../contexts/images'

/**
 * @param children
 * @param props
 * @param router
 * @returns {JSX.Element}
 * @constructor
 */
function ImagesProvider({ children }) {
  // @ts-ignore
  return <StateContext.Provider value={React.useReducer(reducer, initialState)}>{children}</StateContext.Provider>
}

ImagesProvider.propTypes = {
  children: PropTypes.node
}

export default ImagesProvider
